import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.13 Case 13</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_13"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 13. This is a negative case.
                Beginning at the level of the cerebellum and moving superiorly,
                we enter into the overhanging occipital region, seen here. At
                this level, it is difficult to clearly identify distinct white
                matter tracts; therefore, it is important to review the slices
                immediately superior, and in fact, only one slice above, white
                matter tracts come into the field of view.
              </p>
              <p>
                Again moving superiorly, distinct white matter tracts are easily
                delineated on the left-hand side as well as on the right-hand
                side within the temporal and occipital regions. Less intense
                activity is seen in the surrounding gray matter, and there is
                preserved gray-white contrast bilaterally. This pattern of
                preserved gray-white contrast is seen throughout the temporal
                and occipital regions.
              </p>
              <p>
                Continuing to move superiorly and entering into the frontal
                cortices, once again increased activity is seen in the white
                matter on both sides. Less intense activity is seen in the
                surrounding gray matter, and there is preserved gray-white
                contrast throughout. In the parietal regions, white matter
                tracts are easily delineated as they course from the front of
                the brain to the back of the brain on the left- as well as on
                the right-hand side. No increased activity is seen in the gray
                matter.
              </p>
              <p>
                Continuing to move upwards and entering into the medial parietal region, which includes the precuneus, seen here, no increased activity is seen within the gray matter. Increased activity within the white matter tracts, once again identified here on the left as well as on the right, continue to be seen. After reviewing all of the slices, it is clear that there is no loss of gray-white contrast, and this case is negative. If you called this case positive, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-12"
          nextLesson="/module-4/module-4-1-14"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1467411363&entry_id=1_2rdhad0p&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_2rdhad0p"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
